<div class="sx-metering-scope__component"
  *ngIf="showMeteringFilter">
  <header class="sx-metering-scope__header">

    <div class="sx-metering-scope__hotcoldwrapper">
      <div class="sx-metering-scope__section sx-metering-scope__section--rounded-left sx-metering-scope__section--hot" [hidden]="meteringType == 'Cold'">
        <svg class="sx-metering-scope__service-icon">
          <use xlink:href="#sx-varme" href="#sx-varme" />
        </svg>
        <span class="sx-metering-scope__service-text">{{ 'metering.filter.title_hot' | translate }}</span>
      </div>

      <div class="sx-metering-scope__section sx-metering-scope__section--rounded-left sx-metering-scope__section--cold" [hidden]="meteringType == 'Hot'">
        <svg class="sx-metering-scope__service-icon">
          <use xlink:href="#sx-kyla" href="#sx-kyla" />
        </svg>
        <span class="sx-metering-scope__service-text">{{ 'metering.filter.title_cold' | translate }}</span>
      </div>
    </div>

    <div class="sx-metering-scope__contentwrapper">
      <div class="sx-metering-scope__section sx-metering-scope__section--grow sx-metering-scope__titlewrapper" 
        [ngClass]="{'sx-metering-scope__section--rounded-right': meteringPointsCount === 1}">
        <h2 class="sx-metering-scope__heading"
          *ngIf="meteringPointsCount > 1 && (!filterSettings || filterSettings.filterType === filterSettingsTypeEnum.Unfiltered)">
          {{ 'metering.filter.all' | translate }}
        </h2>
        <!-- En anläggning ej vald som filter - Visa anläggningsnamn -->
        <h2 class="sx-metering-scope__headings"
          *ngIf="meteringPointsCount === 1 && (!filterSettings || filterSettings.filterType === filterSettingsTypeEnum.Unfiltered)">
          {{singleMeteringPointName}}
        </h2>

        <h2 class="sx-metering-scope__heading"
          *ngIf="filterSettings && filterSettings.filterType !== filterSettingsTypeEnum.Unfiltered">
          {{filterSettings.name}}
        </h2>

         <!-- Inget Filter satt - Fler än en anläggning -->
        <div [ngClass]="{'sx-metering-scope__subtitle': subfilterEnabled}"
          *ngIf="meteringPointsCount > 1 && (!filterSettings || filterSettings.filterType === filterSettingsTypeEnum.Unfiltered)"
          (click)="toggleSubFilter()">{{meteringPointsCountLabel}} {{ 'metering.filter.subtitle' | translate }}
          <div class="sx-metering-scope__subtitle-select-wrapper" *ngIf="subfilterEnabled">
            <div *ngIf="subfilterEnabled"
              [className]="subfilterOpenState ? 'sx-metering-scope__subtitle-unselect' : 'sx-metering-scope__subtitle-select'">
            </div>
          </div>
        </div>
        <!-- En anläggning ej vald som filter - Visa inte subfilter -->
       
         <!-- Filter satt - Visa subfilter -->
        <div [ngClass]="{'sx-metering-scope__subtitle': subfilterEnabled}"
          *ngIf="filterSettings && filterSettings.filterType !== filterSettingsTypeEnum.Unfiltered && meteringPointsCountLabel.trim().length > 0"
          (click)="toggleSubFilter()">{{meteringPointsCountLabel}} {{ (meteringPointsCountLabel !== "1" ? 'metering.filter.metering_points' : 'metering.filter.metering_point') | translate }}
          <div class="sx-metering-scope__subtitle-select-wrapper" *ngIf="subfilterEnabled">
            <div
              [className]="subfilterOpenState ? 'sx-metering-scope__subtitle-unselect' : 'sx-metering-scope__subtitle-select'">
            </div>
          </div>
        </div>
      </div>

      <div class="sx-metering-scope__functionwrapper">
        <div *ngIf="meteringPointsCount > 1" class="sx-metering-scope__section sx-metering-scope__section--rounded-right sx-metering-scope__section--padless ">
          <button mat-button class="sx-metering-scope__button" (click)="configureFilter()">
            <span class="sx-metering-scope__buttontext-long">{{'metering.filter.edit' | translate}}</span>
            <span class="sx-metering-scope__buttontext-short" aria-hidden="true">{{'metering.filter.edit_short' |
              translate}}</span>
            <svg class="sx-metering-scope__mp-icon">
              <use xlink:href="#sx-andra-urval-for-matpunkter" href="#sx-andra-urval-for-matpunkter"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </header>
    <mat-expansion-panel #subfilterPanel
        (opened)="subfilterOpenState = true"
        (closed)="subfilterOpenState = true"
        *ngIf="subfilterEnabled"
        class="sx-metering-scope__subfilter">
      <div *ngIf="filterSettings && filterSettings.subfilter">
        <div *ngIf="filterSettings.subfilter.includedMeteringPoints" class="sx-metering-scope__subfilter__title">
          {{filterSettings.subfilter.title }}</div>
        <div *ngIf="filterSettings.subfilter.includedMeteringPoints" class="sx-metering-scope__subfilter__grid">
          <div *ngFor="let mp of filterSettings.subfilter.includedMeteringPoints"
            class="sx-metering-scope__subfilter__point">
            <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
              <span>{{mp.name}}</span>
              <span class="sxh-text-mp-id">({{mp.id}})</span>
            </mat-slide-toggle>
          </div>
        </div>
        <div *ngIf="!filterSettings.subfilter.includedMeteringPoints" class="sx-metering-scope__subfilter__grid">
          <div *ngFor="let mp of filterSettings.subfilter.excludedMeteringPoints"
            class="sx-metering-scope__subfilter__point">
            <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
              <span>{{mp.name}}</span>
              <span class="sxh-text-mp-id">({{mp.id}})</span>
            </mat-slide-toggle>
          </div>
        </div>
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
          *ngIf="filterSettings.subfilter.includedMeteringPoints && filterSettings.subfilter.includedMeteringPoints.length > 0 && filterSettings.subfilter.excludedMeteringPoints.length > 0"
          class="sx-metering-scope__subfilter__expansion">
          <mat-expansion-panel-header class="sx-metering-scope__subfilter__expansion-header">
            <mat-panel-title>
              <div class="sx-metering-scope__subfilter__expansion-title">
                {{ 'metering.filter.subfilter_not_included' | translate }}</div>
            </mat-panel-title>
            <mat-panel-description></mat-panel-description>
          </mat-expansion-panel-header>
          <div class="sx-metering-scope__subfilter__grid">
            <div *ngFor="let mp of filterSettings.subfilter.excludedMeteringPoints"
              class="sx-metering-scope__subfilter__point">
              <mat-slide-toggle [checked]="mp.selected" (click)="toggleSelected(mp)">
                <span>{{mp.name}}</span>
                <span class="sxh-text-mp-id">({{mp.id}})</span>
              </mat-slide-toggle>
            </div>
          </div>
        </mat-expansion-panel>
        <div class="sx-metering-scope__subfilter__footer">
          <div>
            <button mat-button class="sx-button sx-metering-scope__subfilter__button" (click)="resetSubfilter()">
              {{ 'metering.filter.subfilter_reset' | translate }}
            </button>
            <button mat-button class="sx-button sx-metering-scope__subfilter__button"
              (click)="toggleAllInSubfilter(true)">
              {{ 'metering.filter.subfilter_select_all' | translate }}
            </button>
            <button mat-button class="sx-button sx-metering-scope__subfilter__button"
              (click)="toggleAllInSubfilter(false)">
              {{ 'metering.filter.subfilter_unselect_all' | translate }}
            </button>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
 </div>
